import React from 'react';

import WeddingLocationStep from '@zola/zola-ui/src/components/OnboardV2/common/steps/WeddingLocationStep/WeddingLocationStep';
import OLDWeddingLocationStep from 'components/onboard/onboard-v2/steps/WeddingLocationStep/WeddingLocationStep';

import FeatureFlags from 'util/featureFlags';

// TODO: remove and point to zola-ui when QA approved
const ConditionalWeddingLocationStep = () =>
  FeatureFlags.get('vendorSearchInWeddingLocationStep') ? (
    <WeddingLocationStep />
  ) : (
    <OLDWeddingLocationStep />
  );

export default ConditionalWeddingLocationStep;
